export default function removeElementAt<T>(index: number, array: T[]) {
  return array.filter((_, i) => i !== index);
}
